"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOutline = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const defaultOutline = exports.defaultOutline = process.env.NODE_ENV === "production" ? {
  name: "1d1mls9",
  styles: "outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color"
} : {
  name: "1mkmepq-defaultOutline",
  styles: "outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;label:defaultOutline;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};